import ApiClient from "@/api/ApiClient.ts";

const state = {
  deliveries: [],
};

const mutations = {
  setDeliveries(state, deliveries) {
    state.deliveries = deliveries;
  },
};

const actions = {
  async getDeliveries({ commit }, params) {
    try {
      const api = ApiClient();
      let response = await api.get("deliverys", params);
      commit("setDeliveries", response.data);
    } catch (error) {
      console.error("ERROR en getDeliveries: ", error.message);
    }
  },

  async getDeliveryById({ rootGetters }, params) {
    try {
      const api = ApiClient();
      let { data } = await api.get("deliverys", { params });
      const centrals = rootGetters["app/centralsByWorkgroupId"](params.wgId);
      let timeZones = data.delivery
        ? data.delivery.timeZones
        : {
            default: [],
          };
      if (timeZones) {
        for (const zone in timeZones) {
          if (Object.hasOwnProperty.call(timeZones, zone)) {
            const elements = timeZones[zone];
            elements.forEach((element) => {
              if (element.centrals && element.centrals.length) {
                element.centrals = centrals
                  .map((central) => {
                    let centralFormatted = null;
                    element.centrals.forEach((_element) => {
                      if (central.id === _element) {
                        centralFormatted = {
                          wgId: central.idWorkgroup,
                          centralId: central.id,
                        };
                      }
                    });
                    return centralFormatted;
                  })
                  .filter((_element) => {
                    return _element !== null;
                  });
              }
            });
          }
        }
      }
      return data;
    } catch (error) {
      console.error("ERROR en getDeliveryById: ", error.message);
      return false;
    }
  },

  async createDelivery(_, payload) {
    const { data, params } = payload;
    try {
      const api = ApiClient();
      await api.post("deliverys/deliverys2", data, {
        params,
        headers: {
          "content-type": "application/json",
        },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateDelivery: ", error.message);
      return false;
    }
  },

  async updateDelivery(_, payload) {
    let timeZones = payload.data.delivery ? payload.data.delivery.timeZones : {};
    if (timeZones) {
      for (const zone in timeZones) {
        if (Object.hasOwnProperty.call(timeZones, zone)) {
          const elements = timeZones[zone];
          elements.forEach((element) => {
            if (element.centrals && element.centrals.length) {
              element.centrals = element.centrals.map((central) => central?.centralId);
            }
          });
        }
      }
    }

    const { params, data } = payload;

    try {
      const api = ApiClient();
      await api.put("deliverys/deliverys2", data, {
        params,
        headers: {
          "content-type": "application/json",
        },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateDelivery: ", error.message);
      return false;
    }
  },
};

const getters = {
  deliveries(state) {
    return state.deliveries;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
